import React from 'react';
import { initReactAppByAttribute } from 'shared/util/ApplicationInit';
import ReviewListing, { ReviewListingProps } from './ReviewListing';

const render = initReactAppByAttribute(
	(props: ReviewListingProps) => <ReviewListing {...props} />,
	'data-reviews-summary',
);

render();

// optional, use this to enable hot reloading
if ((module as any).hot) {
	(module as any).hot.accept('./ReviewListing', () => {
		render();
	});
}
